import { useState } from "react";
import { apiJson } from "./api";

export function SettingsPage() {
  const [msg, setMsg] = useState<string | null>(null);
  const [ocrText, setOcrText] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <>
      <header className="topbar">
        <div className="brand">
          <h1>設定</h1>
          <p>公開JSONの再生成 / ログアウト / OCR（端末内）</p>
        </div>
      </header>

      <section className="card">
        <h2 style={{ marginTop: 0 }}>公開JSON再生成</h2>
        <p className="meta">D1の内容から `/public-data/*.json` 用の KV を作り直します（表サイトのキャッシュ更新にも使えます）。</p>
        <button
          className="btn"
          type="button"
          onClick={async () => {
            setMsg(null);
            try {
              const r = await apiJson<{ months: string[] }>("/api/admin/regenerate-json", { method: "POST" });
              setMsg(`OK: months=${r.months.join(",")}`);
            } catch (e) {
              setMsg(String(e));
            }
          }}
        >
          再生成する
        </button>
        {msg && <pre className="mono" style={{ whiteSpace: "pre-wrap" }}>{msg}</pre>}
      </section>

      <section className="card" style={{ marginTop: 12 }}>
        <h2 style={{ marginTop: 0 }}>ログアウト</h2>
        <button
          className="btn secondary"
          type="button"
          onClick={async () => {
            await apiJson("/api/auth/logout", { method: "POST" });
            window.location.href = "/admin/login";
          }}
        >
          ログアウト
        </button>
      </section>

      <section className="card" style={{ marginTop: 12 }}>
        <h2 style={{ marginTop: 0 }}>OCR入力（サーバーに画像は送りません）</h2>
        <p className="meta">画像を選ぶと、この端末の中だけで文字認識します（重いので Wi-Fi 推奨）。</p>
        <input
          type="file"
          accept="image/*"
          onChange={async (ev) => {
            const file = ev.target.files?.[0];
            if (!file) return;
            setBusy(true);
            setOcrText(null);
            try {
              const mod = await import("tesseract.js");
              const r = await mod.recognize(file, "jpn+eng", { logger: () => {} });
              setOcrText(String(r.data.text ?? ""));
            } catch (e) {
              setOcrText(`失敗: ${String(e)}`);
            } finally {
              setBusy(false);
            }
          }}
        />
        {busy && <p>読み取り中…</p>}
        {ocrText && (
          <textarea className="input" rows={8} style={{ marginTop: 10 }} value={ocrText} onChange={(e) => setOcrText(e.target.value)} />
        )}
      </section>
    </>
  );
}
